
import { Transaction } from '@/types/transaction';

export function filterTransactions(
  transactions: Transaction[],
  paymentMethod: string | null,
  keepMoreStatus: string | null,
  minAmount?: number
): Transaction[] {
  let result = [...transactions];

  if (paymentMethod) {
    // Handle payment method filtering
    result = result.filter(tx => {
      // Handle both paymentMethod property and payment_method_types array
      if (tx.paymentMethod) {
        return tx.paymentMethod === paymentMethod;
      } else if (Array.isArray(tx.payment_method_types)) {
        return tx.payment_method_types.includes(paymentMethod);
      }
      return false;
    });
  }

  if (keepMoreStatus !== null) {
    const isKeepMore = keepMoreStatus === 'true';
    // Fix: Properly handle the KeepMore status checking for both property names
    result = result.filter(tx => {
      // Check both possible flag names and convert to boolean
      const txIsKeepMore = 
        (tx.is_keepmore_transaction === true || tx.isKeepMoreTransaction === true) &&
        !(tx.is_keepmore_transaction === false || tx.isKeepMoreTransaction === false);
      return txIsKeepMore === isKeepMore;
    });
  }

  if (minAmount !== undefined && minAmount > 0) {
    // minAmount is already in dollars (e.g., 1145.95), don't convert it again
    
    // Improved filtering with proper amount comparison
    result = result.filter(tx => {
      // Try different amount properties, ensuring we're comparing in the same units (dollars)
      let txAmountDollars: number;

      if (tx.net_amount_cents !== undefined && tx.net_amount_cents !== null) {
        // Convert cents to dollars
        txAmountDollars = tx.net_amount_cents / 100;
      } else if (tx.net_received_cents !== undefined && tx.net_received_cents !== null) {
        // Convert cents to dollars
        txAmountDollars = tx.net_received_cents / 100;
      } else if (tx.gross_amount_cents !== undefined && tx.gross_amount_cents !== null) {
        // Convert cents to dollars
        txAmountDollars = tx.gross_amount_cents / 100;
      } else if (tx.amount !== undefined && tx.amount !== null) {
        // amount is already in dollars
        txAmountDollars = tx.amount;
      } else {
        // Default to zero if no amount found
        txAmountDollars = 0;
      }
      
      // Debug each transaction's amount comparison
      const include = txAmountDollars >= (minAmount * 100);
      
      return include;
    });
  }

  return result;
}
